import { FollowupOnlineSearchState } from './types';

const INITIAL_STATE: FollowupOnlineSearchState = {
  followupOnlineSearch: {
    filters: {
      updated: false,
      id: '',
      publicBodyTypes: [],
      processNumber: '',
      object: '',
      address: '',
      publicBody: '',
      noticeNumber: '',
      includeDateRange: { from: null, to: null },
      states: [],
      region: null,
      cities: [],
      modalities: [],
      activities: [],
      summary: '',
    },
    currentPage: 1,
    postsPerPage: 20,
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

export default INITIAL_STATE;
